/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDirectionHorizontal = createReactComponent("outline", "direction-horizontal", "IconDirectionHorizontal", [["path", { "d": "M10 9l-3 3l3 3", "key": "svg-0" }], ["path", { "d": "M14 9l3 3l-3 3", "key": "svg-1" }]]);

export { IconDirectionHorizontal as default };
//# sourceMappingURL=IconDirectionHorizontal.mjs.map
